import * as ToggleGroup from '@radix-ui/react-toggle-group'
import * as React from 'react'

import { TileInteractive } from '~/components/tile-interactive/TileInteractive'
import { styled } from '~/styled'

const StyledTileToggleGroupItem = styled(TileInteractive, {
  base: [
    'text-left',
    'not-disabled:data-[state=on]:active:bg-(--interactive-3)',
    'not-disabled:data-[state=on]:hover:bg-(--interactive-2)',
    'data-[state=on]:before:-inset-px',
    'data-[state=on]:before:absolute',
    'data-[state=on]:before:rounded-[inherit]',
    'data-[state=on]:before:inset-shadow-[var(--accent-8)_0px_0px_0px_2px]',
    'data-[state=on]:before:z-1',
    'data-[state=on]:bg-(--interactive-1)',
    'data-[state=on]:border-(--accent-8)'
  ]
})

type TTileToggleGroupItem = React.ComponentProps<typeof ToggleGroup.Item> &
  React.ComponentProps<typeof StyledTileToggleGroupItem>

export const TileToggleGroupItem = ({
  children,
  ...rest
}: TTileToggleGroupItem) => (
  <ToggleGroup.Item {...rest} asChild>
    <StyledTileToggleGroupItem as="button">
      {children}
    </StyledTileToggleGroupItem>
  </ToggleGroup.Item>
)
